import { Dispatch, SetStateAction } from 'react';
import useFilter from './hooks/useFilter';
import styled from '@emotion/styled';
import { VALID_REGIONS } from './constants';
import { Dropdown, FlexRow, H5, Styles } from 'toolkit/components';

const DropDownWrapper = styled(Dropdown)`
  border: 1px solid ${Styles.colors.grey.secondaryDark};
`;

interface FilterWrapperProps {
  filterState: string;
  setFilterState: Dispatch<SetStateAction<string>>;
}

export default function Filter({ filterState, setFilterState }: FilterWrapperProps) {
  const TriggerButton = () => (
    <FlexRow margin="small">
      <span>
        <H5>{filterState}</H5>
      </span>
    </FlexRow>
  );

  const dropdownActions = useFilter(
    filterState,
    setFilterState,
    'contentValueRegion',
    VALID_REGIONS
  );

  return <DropDownWrapper links={dropdownActions} Trigger={TriggerButton} fullWidth triggerArrow />;
}
